import { render, staticRenderFns } from "./TheCart.vue?vue&type=template&id=24b386cc&scoped=true&"
import script from "./TheCart.vue?vue&type=script&lang=js&"
export * from "./TheCart.vue?vue&type=script&lang=js&"
import style0 from "./TheCart.vue?vue&type=style&index=0&id=24b386cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b386cc",
  null
  
)

export default component.exports